module.exports = __webpack_public_path__ + "img/hero_basket.2b503b9f.jpg";